<template>
  <div class="information">
<!--    <div>-->
<!--      <otherNav></otherNav>-->
<!--    </div>-->
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 information-item">
        <h4 class="item-h4" style="float:left;">动态资讯</h4>
        <template v-if="tableData.length>0">
        <el-table
            :data="tableData"
            style="width: 100%">
          <el-table-column
              pr prop="title"
              label=""
              show-overflow-tooltip
              style="text-align: left">
            <template slot-scope="scope">
              <router-link class="list-title" :to="'/detail/'+ scope.row.id+'/'+scope.row.type"
                           :detailId="scope.row.id">{{scope.row.title }}</router-link>
            </template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              width="100px">
          </el-table-column>
        </el-table>

          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="totalPage">
          </el-pagination>
        </template>
        <el-empty description="没有找到数据" style="width: 20%;margin: 0 auto" v-else></el-empty>
<!--        </el-card>-->
      </div>
    </div>
  </div>
</template>

<script>
import otherNav from '@/components/navBar/otherNav'
import breadcrumb from '@/components/breadcrumb/index'
import {fetchList, getObj} from "@/network/dynamic/information";
export default {
  name: "information",
  components: { breadcrumb, otherNav },
  data() {
    return {
      path: '',
      name: '',
      childName:'',
      childPath:'',
      pageSize: 10,
      page: 1,
      totalPage: 0,
      tableData: [],
      type: 'information',
      infoContent:{},
      formInline:{}
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      // vm.name = from.name
      vm.name = '动态'
    })
  },
  mounted() {

    this.getList()
    this.$nextTick(() => {

    })
  },

  created() {
    // this.childName = this.$route.name
    this.childName = '动态资讯'
    this.childPath = this.$route.path
  },
  methods: {
    getList() {
      fetchList(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.type
      })).then(response => {
        // console.log('123:',response)
        this.tableData = response.data.data.records
        this.totalPage = response.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    openDetail(id){
      this.$router.push({
        path: '/detail',
        params: {
          id: id,
          infoContent: this.infoContent
        },
      })
      getObj(id).then(res => {
        // console.log(res.data.data)
        this.infoContent = res.data.data
      })
    },
    onSubmit(){},
    handleSelect(key, keyPath) {
      this.$router.push({path:key}).catch(err => {
        // console.log(err)
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/information";
::v-deep .el-pagination {
  padding: 20px 5px;
  text-align: center;
}
</style>